import React from "react";

export function Signup() {
    return <div>Signup</div>;
}
